var _Skeleton;
import * as React from 'react';
import { Grid2, IconProviderOutlined, Skeleton, Stack } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ListAvailabilitiesByProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(Grid2, {
    container: true,
    gridColumn: 2,
    children: [/*#__PURE__*/_jsx(Grid2, {
      xs: 4,
      sx: {
        minWidth: 'fit-content'
      },
      children: /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 2,
        flex: 1,
        flexWrap: "nowrap",
        children: [/*#__PURE__*/_jsx(IconProviderOutlined, {
          sx: function sx(theme) {
            return {
              color: theme.palette.text.disabled
            };
          }
        }), _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
          width: "130px",
          height: "32px"
        }))]
      })
    }), /*#__PURE__*/_jsx(Grid2, {
      xs: 8,
      children: /*#__PURE__*/_jsx(Grid2, {
        container: true,
        gap: 1,
        children: children
      })
    })]
  });
}